import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { round } from 'lodash'
import { D101_0, P151_1, VP_020, VP_056 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'

const DialogP151_1 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntity] = useState(managementEntity)

    useEffect(() => {
        setEntity(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const rows = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_020.code,
            indicatorName: i18n[VP_020.i18n],
            unit: i18n.amount,
            onChange: v => setEntity(prev => (updateIndicatorEntity(prev, year, VP_020.code,
                { ...currentEntity?.[VP_020.code], value: parseInt(v) || 0 },
            ))),
        }),

        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_056.code,
            indicatorName: i18n[VP_056.i18n],
            unit: i18n.subscriber,
            resumption: D101_0.name,
        }),
    ]

    const onStatusChange = (status) => {
        setEntity(updateIndicatorEntity(entityDialog, year, P151_1.code, { ...currentEntity?.[P151_1.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_056) != 0 ? round(getIndicatorValue(VP_020) / getIndicatorValue(VP_056) * 1000, 2) : 0

        return updateIndicatorEntity(entityDialog, year, P151_1.code, { ...currentEntity?.[P151_1.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntity}
            codeIndicator={P151_1.code}
            calculationOnRegister={calculation}
        >
            {year && previousYear &&
                <Grid container direction={'column'} gap={2} size={12}>
                    <IndicatorHeaderDialog
                        current={{
                            year,
                            value: managementEntity?.[year]?.[P151_1.code]?.value,
                        }}
                        previous={{
                            year: previousYear,
                            value: managementEntity?.[previousYear]?.[P151_1.code]?.value,
                        }}
                        status={entityDialog?.[year]?.[P151_1.code]?.status}
                        onStatusChange={onStatusChange}
                        unit={i18n.workingDay}
                    />
                    <Divider/>
                    <IndicatorTable
                        year={year.toString()}
                        indicators={rows}
                    />

                </Grid>
            }
        </EntityIndicatorDialog>
    )
}

DialogP151_1.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP151_1
